/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/form-field/custom-elements';

import { defineCustomElement as defineOsdsFormField } from '@ovhcloud/ods-stencil/components/form-field/custom-elements/osds-form-field.js';

export const OsdsFormField = /*@__PURE__*/createReactComponent<JSX.OsdsFormField, HTMLOsdsFormFieldElement>('osds-form-field', undefined, undefined, defineOsdsFormField);
